<template>
<div style="margin-left: -40px;">
  <modal-ayuda></modal-ayuda>
  <v-row  style="margin-top:-35px;">
    <v-card width="100%">
      <v-tabs
        background-color="teal darken-3"
        center-active
        dark
      >
        <v-tab  v-for="(menu,index) in puntos_medicion"
            :id="`menu_${index}`"  :key="menu.id" @click="obtenerParametros(menu.id)">{{ menu.nombre_punto }}</v-tab>
      </v-tabs>
    </v-card>
  </v-row>
  <loader-compartido></loader-compartido>

  <v-row>
    <v-col style="padding-top:15px;margin-left: -15px;">
      <tabla-registro-lectura-laboratorio class="ml-2 mr-2"
        :scroll_auto="`${true}`"
      ></tabla-registro-lectura-laboratorio>
    </v-col>
  </v-row>
</div>
</template>

<script>
import {mapState,mapMutations,mapActions} from 'vuex';
// import Loader_Lineal from '@/components/shared/Loader_Lineal.vue';
// import Loader_Lineal_Configurable from '../../components/shared/Loader_Lineal_Configurable.vue';
import Tabla_Registro_Lectura_Laboratorio from '../../components/shared/Tabla_Registro_Lectura_Laboratorio.vue';
import Loader_Compartido from '@/components/shared/Loader_Compartido.vue';

//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data:()=> ({
        roles_permitidos:['laboratorio','admin'],
        punto_medicion_actual:{},
        puntos_medicion:[],
        mostrar_fecha:false,
        mostrar_inicio:false,
        mostrar_termino:false,
        mostrarFechas: false,
        mostrarDescargarExcel: false,
        fecha_picker: new Date().toISOString().substr(0, 10),
        fecha_inicio: new Date().toISOString().substr(0, 10),
        fecha_termino: new Date().toISOString().substr(0, 10),
        rango_fechas:null,
        opcion_excel: 0,
        orden_fechas: 0,
        ajustes_tabla:{
            columnas_inicio:[
                {
                  titulo:'',
                  titulo_visible:true,
                  cabecera:'Fecha - Hora',
                  colspan:2,
                  subcolumnas:[
                    {cabecera:'Fecha',key:'fecha',visible:true,fixed:1,tipo:'texto'},
                    {cabecera:'Hora',key:'hora',visible:true,fixed:2,tipo:'texto'},
                  ]
                }
            ],
            columnas_final:[
                {
                  titulo:'',
                  titulo_visible:true,
                  cabecera:'Usuarios',
                  colspan:3,
                  subcolumnas:[
                    {cabecera:'Analista',key:'analista',visible:true,fixed:0,tipo:'select',opciones:[],texto:'name',seleccion:'id',label:'Analista'},
                    {cabecera:'Muestreador',key:'muestreador',visible:true,fixed:0,tipo:'select',opciones:[],texto:'name',seleccion:'id',label:'Muestreador'},
                    {cabecera:'J. Turno',key:'jefe_turno',visible:true,fixed:0,tipo:'select',opciones:[],texto:'name',seleccion:'id',label:'J. Turno'},
                  ]
                }
            ],
            tipos:[],
            acciones:[]
        },
        registros:[],
        analistas:[],
        muestreadores:[],
        jturnos:[],
        positionPointMedition: 0
    }),
    mounted() {
        this.detectarIP();
        this.comprobarPermisos();
        this.positionPointMedition = 0;
        this.intervalId = setInterval(() => {
            if (this.puntos_medicion.length > 0) {
                if (this.positionPointMedition == this.puntos_medicion.length - 1) {
                    this.positionPointMedition = 0;
                } else {
                    this.positionPointMedition++;
                }
                var button_menu = document.getElementById(`menu_${this.positionPointMedition}`);
                button_menu.click();
            }
        }, 1000 * 60 * 1); //un minuto

        this.intervalUpload = setInterval(()=>{
          this.obtenerParametros(this.puntos_medicion[this.positionPointMedition].id,false);
        }, 1000 * 20); //20 segundos
        //this.cargarPuntosMedicion();
        // Scroll a una posición específica
    },
    unmounted() {
        clearInterval(this.intervalId);
        clearInterval(this.intervalUpload);
    },
    methods: {
        async detectarIP(){
            let url_actual = window.location.href;
            let url_auth = process.env.VUE_APP_IPS_AUTH;
            url_auth = url_auth.split(',');
            const validate_auth_ip = url_auth.find(url=>url_actual.includes(url));
            console.log(validate_auth_ip);
            if(validate_auth_ip){
                console.log(process.env.VUE_APP_BY_PASS_USER);
                let credentials = {
                    user: process.env.VUE_APP_BY_PASS_USER,
                    password: process.env.VUE_APP_BY_PASS_PASSWORD
                };
                await this.axios.post(this.base_url+'login',credentials).then((response)=>{
                    if(response.data.access_token == ""){
                        //this.mostrarLoading('Credenciales Incorrectas')
                    }else{
                        let data = response.data;
                        // console.log(data);
                        data = {...data, ...{kiosk:true}};
                        this.iniciarSession(data)
                    }
                }).catch((error)=>{
                    console.log('error',error)
                })
            }
        },
        abrirAyudas() {
          const jiji = [
            {   titulo:`Ayuda de Reporte Bitácora`,    tipo:`titulo`},
            {   tipo:`label`,   texto:`En esta pantalla se muestran los maxisacos de cada lote según los análisis que se obtuvieran.`},
            {   tipo:`label`,   texto:`- En la barra de desplazamiento de arriba se selecciona el punto de medición de la bitácora.`},
            {   tipo:`label`,   texto:`- En la tabla inferior se muestra cada maxisaco, la fecha y hora de producción, observaciones, código, lote, número de maxisaco y los resultados de los análisis por cada parámetro que corresponda.`},
            {   tipo:`label`,   texto:`- Pulsando en el texto "Buscar | Exportar a Excel", se abre un menú de opciones para la exportación en formato Excel de la bitácora en recuadro de color verde, en el que se puede indicar las fecha que se quiere exportar o la hoja actual y el orden en que se quiere que se muestren los registros. Con el botón "Excel" se realiza la exportación.`},
            {   tipo:`label`,   texto:`- El recuadro celeste (luego de mostrar opciones) sirve para buscar la bitácora según la fecha indicada. Con el botón "buscar" se realiza esta búsqueda y finalmente se muestra en la tabla de abajo la bitácora de esa fecha indicada.`},
          ];
          
          Event.$emit('mostrar_alert',jiji);
        },
        async comprobarPermisos(){
          let acceder = false;
          await this.roles_permitidos.forEach(async(rol) => {
            await this.roles.forEach(rol_u => {
              if(rol_u == rol){
                acceder = true;
              }
            });
          });
          if(!acceder){
            this.$router.push('/');
          }else{
            this.cargarPuntosMedicion();
          }
        },
        async cargarPuntosMedicion(){
            //this.mostrarLoading('Cargando Puntos de Medición...')
            this.mostrarLoading({titulo:'Cargando Puntos de Medición...',color:'green'})

            let url = `${this.base_url}punto_medicion_screen`
            await this.axios.get(url,this.headers).then((response)=>{
                // console.log('puntos de medicion',response.data.data)
                this.puntos_medicion = response.data.data
                this.puntos_medicion.sort(function(a, b){return a.orden - b.orden});
                this.ocultarLoading()
                this.obtenerParametros(this.puntos_medicion[0].id)
            }).catch((error)=>{
                console.log('error',error)
                this.ocultarLoading()
            })
        },
        async obtenerParametros(id, load = true){
          //this.mostrarLoading('Cargando...');
          load&&this.mostrarLoading({titulo:'Cargando...',color:'green'})

          this.restablecerAjustes();

          let pm = this.puntos_medicion.filter((punto)=>{
            return punto.id == id;
          });
          this.punto_medicion_actual = pm[0];
          // console.log('punto de medicion actual',this.punto_medicion_actual);
          let punto_medicion_id = pm[0].id;
          
          //agrega las columnas adicionales que son unicas dependiendo del tipo de punto de medicion (linea,jumbo)
          await this.agregarColumnasAdicionales(pm[0].tipo_punto);
          //agrega los usuarios analistas, muestreadores y jefes de turno
        //   await this.cargarUsuarios();
          //carga los ultimos 20 registros del punto de medicion seleccionado
          await this.cargarUltimosRegistros(punto_medicion_id, load);

            // console.log('punto_mediciones_id',id);
            //peticion que carga los parametros de un punto de medicion
            let url = `${this.base_url}punto_medicion/parametros_screen/${id}`;
          //this.mostrarLoading('Generando Tabla...');
          load&&this.mostrarLoading({titulo:'Generando Tabla...',color:'green'})

          await this.axios.get(url,this.headers).then((response)=>{
                
                let parametros = response.data.data;
                //realiza una busqueda de los tipos de equipo que sean distintos
                let tipos = this.buscarTiposEquiposDistintos(parametros);
                // console.log('tipos de equipo distintos',tipos);

                //busca todos los equipos que sean distintos (ademas carga los parametros del equipo)
                let equipos_distintos = this.buscarEquiposDistintos(parametros);
                // console.log('equipos_distintos',equipos_distintos);

                // asigna los equipos a los tipos de equipo
                let ajustes_finales = this.asignarEquiposATiposDeEquipo(tipos,equipos_distintos);
                //console.log('ajustes_finales',ajustes_finales);

                //se realiza el seteo de los ajustes para la tabla_registro
                this.ajustes_tabla.tipos = ajustes_finales;
                //this.ajustes_tabla.equipos = this.buscarEquiposDistintos(indicadores)
                //console.log('ajustes_tabla',this.ajustes_tabla);
                this.$emit('crear_tabla',this.ajustes_tabla,this.registros,this.punto_medicion_actual);
                load&&this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                load&&this.ocultarLoading();
            })
        },

        async cargarUltimosRegistros(punto_medicion_id, load = true){
          //this.mostrarLoading('Cargando Últimos Registros...');
          load&&this.mostrarLoading({titulo:'Cargando Últimos Registros...',color:'green'});
          let inicio = null;
          let termino = null;
          if(this.fecha_picker){
            inicio = ((this.fecha_picker[0] != null) && (this.fecha_picker[0].length > 6 )) ? this.fecha_picker[0] : null;
            termino = ((this.fecha_picker[1] != null) && (this.fecha_picker[1].length > 6 )) ? this.fecha_picker[1] : null;
          }
          console.log('inicio',inicio,'termino',termino);

          let url = `${this.base_url}punto_medicion/resultados/${punto_medicion_id}/${inicio}/${termino}`;
            await this.axios.get(url,this.headers).then((response)=>{
              // console.log('ultimos registros laboratorio',response.data.data);
              this.registros = response.data.data;
              load&&this.ocultarLoading();
            }).catch((error)=>{
              console.log('error',error);
              load&&this.ocultarLoading();
            })
        },

        asignarEquiposATiposDeEquipo(tipos,equipos_distintos){
          tipos.forEach(tipo => {
            let colspan = 0;
            equipos_distintos.forEach(equipo => {
              if(tipo.tipo_equipo_id == equipo.tipo_equipo_id){
                tipo.equipos.push(equipo)
                colspan+=equipo.colspan;
              }
            });
            //ordenando los equipos de cada tipo de equipo
            tipo.equipos = tipo.equipos.sort(function(a, b){return a.orden - b.orden});
            //console.log('equipos_ordenados',tipo.equipos);
            tipo.colspan = colspan;
          });
          return tipos;
        },

        buscarTiposEquiposDistintos(parametros){
          let map = new Map();
          let tipos = [];
          parametros.forEach(par=>{
            if(!map.has(par.equipos_procesos.tipo_equipos_id)){
                map.set(par.equipos_procesos.tipo_equipos_id,true);
                tipos.push({
                  tipo_equipo_id:par.equipos_procesos.tipo_equipos_id,
                  tipo_equipo:par.equipos_procesos.tipo_equipo.tipo_equipo,
                  visible:true,
                  equipos:[]
                });
            }
          });

          return tipos;
        },

        buscarEquiposDeTipoDeEquipo(parametros,tipo_equipo_id){
          let equipos = [];
          let equipos_distintos = this.buscarTiposEquiposDistintos(parametros);
          equipos_distintos.forEach(equipo => {
            if(equipo.tipo_equipo_id==tipo_equipo_id){
              equipos.push(equipo);
            }
          });
          
          return equipos;
        },
        
        buscarEquiposDistintos(array){
          // console.log('parametros',array);
          //array corresponde a los parametros
            let map = new Map();
            let equipos = [];
            array.forEach(item => {
                //llenando los parametros
                //this.ajustes_tabla.indicadores.push({id:item.id,nombre_indicador:item.indicadores.nombre_indicador,visible:true,fixed:0})
                //buscando los equipos distintos
                if(!map.has(item.equipos_procesos_id)){
                        map.set(item.equipos_procesos_id, true);    // set any value to Map
                        
                        //buscando los parametros del equipo
                        let parametros = [];
                        array.forEach(parametro => {
                          if(parametro.equipos_procesos_id==item.equipos_procesos_id){
                            parametros.push({
                              id:parametro.id,
                              nombre_parametro:parametro.parametros.nombre_parametro,
                              nombre_equipo:parametro.equipos_procesos.nombre_equipo,
                              equipos_procesos_id:parametro.equipos_procesos_id,
                              unidad_medida:parametro.unidad_medida.nombre_corto,
                              orden:parametro.orden,
                              visible:true,
                              formula:parametro.formulas,
                              valor_minimo:parametro.valor_minimo,
                              valor_maximo:parametro.valor_maximo,
                              alarma_1:parametro.alarma01,
                              signo_1:parametro.signo01,
                              alarma_2:parametro.alarma02,
                              signo_2:parametro.signo02,
                              optimo_minimo:parametro.optimo_minimo,
                              optimo_maximo:parametro.optimo_maximo,
                              tipo:parametro.parametros.tipo,
                              opciones:parametro.parametros.opciones_activas,
                              fixed:0});
                          }
                        });

                        //ordenando los parametros
                        parametros = parametros.sort(function(a, b){return a.orden - b.orden});

                        //agregando el equipo con sus parametros
                        equipos.push({
                            equipos_procesos_id:item.equipos_procesos_id,
                            tipo_equipo_id:item.equipos_procesos.tipo_equipos_id,
                            parametros:parametros,
                            cabecera:item.equipos_procesos.nombre_equipo,
                            colspan:this.calcularColspan(item.equipos_procesos_id,array),
                            orden:item.equipos_procesos.orden});
                }
            })
            return equipos;
        },
        calcularColspan(id_equipo,array){
            let colspan = 0;
            array.forEach(item => {
                if(item.equipos_procesos_id == id_equipo){
                    colspan++;
                }
            });
            return colspan;
        },

        restablecerAjustes(){
          this.ajustes_tabla = {
              columnas_inicio:[
                {
                  titulo:'',
                  titulo_visible:true,
                  cabecera:'Fecha - Hora',
                  colspan:2,
                  subcolumnas:[
                    {cabecera:'Fecha',key:'fecha',visible:true,fixed:1,tipo:'texto'},
                    {cabecera:'Hora',key:'hora',visible:true,fixed:2,tipo:'texto'},
                  ]
                }
              ],
              columnas_final:[
                  // {
                  //   titulo:'',
                  //   titulo_visible:true,
                  //   cabecera:'Responsable',
                  //   colspan:3,
                  //   subcolumnas:[
                  //     {cabecera:'Analista',key:'analista',visible:true,fixed:0,tipo:'select',opciones:[],texto:'name',seleccion:'id',label:'Analista'},
                  //     {cabecera:'Muestreador',key:'muestreador',visible:true,fixed:0,tipo:'select',opciones:[],texto:'name',seleccion:'id',label:'Muestreador'},
                  //     {cabecera:'J. Turno',key:'jefe_turno',visible:true,fixed:0,tipo:'select',opciones:[],texto:'name',seleccion:'id',label:'J. Turno'},
                  //   ]
                  // }
              ],
              tipos:[],
              acciones:[]
          };
          this.registros = [];
        },

        async agregarColumnasAdicionales(tipo_punto){
          if(tipo_punto == 'linea'){
            
            // this.ajustes_tabla.columnas_inicio.push({
            //       titulo:'',
            //       titulo_visible:true,
            //       cabecera:'Materia Prima',
            //       colspan:1,
            //       subcolumnas:[
            //         {cabecera:'MP',key:'tipo_mps_id',visible:true,solo_lectura:false,fixed:0,tipo:'select',opciones:[],texto:'tipo_materia_prima',seleccion:'id',label:'Materia Prima'},
            //       ]
            // });
            // await this.cargarMateriasPrimas();
          }else if(tipo_punto == 'jumbo'){
            /*this.ajustes_tabla.columnas_inicio.push({
              titulo:'',
              titulo_visible:true,
              cabecera:'C.Planta',
              colspan:1,
              subcolumnas:[
                {cabecera:'C.Planta',key:'control_planta',visible:true,solo_lectura:true,fixed:0,tipo:'texto'}
              ]
            });*/
            this.ajustes_tabla.columnas_inicio.push({
              titulo:'',
              titulo_visible:true,
              cabecera:'C.Planta',
              colspan:1,
              subcolumnas:[
                {cabecera:'C.Planta',key:'control_planta',visible:true,solo_lectura:true,fixed:0,tipo:'texto'}
              ]
            });
            this.ajustes_tabla.columnas_inicio.push({
              titulo:'',
              titulo_visible:true,
              cabecera:'Lote',
              colspan:1,
              subcolumnas:[
                {cabecera:'N° Lote',key:'nombre_lote',visible:true,fixed:0,tipo:'label'}
              ]
            });
            this.ajustes_tabla.columnas_inicio.push({
              titulo:'',
              titulo_visible:true,
              cabecera:'Maxisaco',
              colspan:1,
              subcolumnas:[
                {cabecera:'Maxisaco N°',key:'nro_jumbo',visible:true,fixed:0,tipo:'label'}
              ]
            });
            // console.log(this.ajustes_tabla.columnas_inicio);
          }else if(this.punto_medicion_actual.id == 8){
            /**punto de medicion lotes completos */
            this.ajustes_tabla.columnas_inicio.push({
              titulo:'',
              titulo_visible:true,
              cabecera:'',
              colspan:1,
              subcolumnas:[
                {cabecera:'Lote',key:'lotes_id',visible:true,solo_lectura:false,fixed:0,tipo:'select',opciones:[],texto:'nombre_lote',seleccion:'id',label:'Seleccione Lote'},
              ]
            });

            // await this.cargarLotes();
          }
        },

        async crearExcel(){
          let fecha_inicio = this.fecha_inicio != ''? this.moment(this.fecha_inicio).format('YYYY-MM-DD'):'';
          let fecha_termino = this.fecha_termino != ''? this.moment(this.fecha_termino).format('YYYY-MM-DD'):'';
          let punto_medicion = this.punto_medicion_actual.id;
          if(this.opcion_excel == 0){
            punto_medicion = 0;
          }
          let url = `${this.base_url}resultados/bitacora/${fecha_inicio}/${fecha_termino}/${punto_medicion}`;
          await this.axios.get(url, this.headers).then((response)=>{
            // console.log(response.data.data);
            window.location.href = response.data.data;
          }).catch((error)=>{
            console.log('error', error);
          });
        },

        async descargarExcel(){
          // console.log('rango fechas',this.rango_fechas);
          if(this.rango_fechas){
            let inicio = this.rango_fechas[0];
            let termino = this.rango_fechas[1];
            let orden = this.orden_fechas;
            let p_m = this.opcion_excel == 0? 0 : this.punto_medicion_actual.id;
            let url = `${this.base_url}resultados/bitacora/${inicio}/${termino}/${p_m}/${orden}`;
            this.mostrarLoading({titulo:'Generando Información...',color:'green'})

            await this.axios.get(url, this.headers).then((response)=>{
              // console.log(response.data.data);
              this.ocultarLoading();
              window.location.href = response.data.data;
            }).catch((error)=>{
              console.log('error', error);
              this.mostrarLoading({titulo:'Error...' + error,color:'red'})
            });
          }
        },

        async buscar_registros(){
          console.log("fecha_picker",this.fecha_picker)
          if(this.fecha_picker){
            let inicio = this.fecha_picker[0];
            let termino = this.fecha_picker[1];
            let orden = this.orden_fechas;
            let conf = {
              color:'#00796B'
            }
            this.mostrarLoading({titulo:'Cargando Información... si la búsqueda contiene muchos días demorará más ...',color:'green'})
            this.$emit('iniciar',conf);
            let url = `${this.base_url}punto_medicion/${this.punto_medicion_actual.id}/resultados/fecha/${inicio}/${termino}/${orden}`;
            await this.axios.get(url,this.headers).then((response)=>{
              this.registros = response.data.data;
              this.$emit('crear_tabla',this.ajustes_tabla,this.registros,this.punto_medicion_actual);
              this.$emit('terminar');
              this.ocultarLoading();
            }).catch((error)=>{
              console.log('error',error);
              this.mostrarLoading({titulo:'Error...' + error,color:'red'})
            });
          }
        },
        ...mapActions(['iniciarSession']),
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState({
          base_url:state => state.base_url,
          headers:state => state.headers,
          roles: state => state.roles_prod
        }),
        mostrarBotonAgregar(){
            if(this.ajustes_tabla.tipos.length>0){
              return false;
            }else{
              return true;
            }
        },

        mostrarBotonExcel(){
            if(this.ajustes_tabla.tipos.length>0){
              return false;
            }else{
              return true;
            }
        },

        fecha_formateada () {
          //return this.fecha_picker ? this.moment(this.fecha_picker).format('DD-MM-YYYY') : '';
        }
    },
    components:{
        'tabla-registro-lectura-laboratorio':Tabla_Registro_Lectura_Laboratorio,
        'loader-compartido':Loader_Compartido,
        DatePicker,
        'modal-ayuda': ModalAyudas,
    },
  }
</script>